import { Button, Card, Search, Table } from "@veneer/core";
import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { apiPost } from "../../../services/service";
import {
  POST_GET_MATCH_COUNT,
  POST_PRODUCT_INFO,
  POST_PRODUCT_LOAD_MATCHING_CASE,
} from "../../../services";
import React from "react";
import Exporttoexcel from "../case-homepage/cases/exporttoexcel";
import { useNavigate, useSearchParams } from "react-router-dom";
import CaseItems from "@components/home-page/shared-components/case-items/case-items";
import "./matching-case.scss";
import { useTranslation } from "react-i18next";
import Loader from "../shared-components/loader/loader";

export const MatchingCase = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Error, setError] = useState("null");
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [showMatch, setShowMatch] = useState(false);
  const [lblCaseWarningMessage, setlblCaseWarningMessage] = useState("");
  const [getProductInfo, setProductInfo] = React.useState<any>([]);
  const [getPolyProductInfo, setPolyProductInfo] = React.useState<any>([]);
  const [progress, setProgress] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const pagination = [{}];
  const pageSize = 10;
  const [currentPage, setCurrentPage] = React.useState(1);

  const pagedData = pagination
    ? tableData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
      )
    : tableData;

  const paginationProps = pagination
    ? {
        currentPage,
        pageSize,
        onPageChange: (page: number) => {
          setCurrentPage(page);
        },
        totalItems: tableData.length,
      }
    : undefined;

  React.useEffect(() => {
    if (!pagination) {
      setCurrentPage(1);
    }
  }, [pagination]);

  const handleSearch = (value: string | undefined, field: string) => {
    if (!value) {
      setTableFliterData(pageLoad);
      return;
    }
    let filtered: any = pageLoad.filter((item: any) => {
      return item?.[field]?.toLowerCase()?.includes(value.trim().toLowerCase());
    });
    setTableFliterData(filtered);
  };

  const columns = [
    {
      id: "hpi_caseid",
      label: t("HPI.CaseMatching.CaseID", { defaultValue: "Case ID" }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.CaseID", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_caseid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_subject",
      label: t("HPI.CaseMatching.CaseTitle", { defaultValue: "Case Title" }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.CaseTitle", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          name="hpi_subject"
          onChange={(v) => handleSearch(v, "hpi_subject")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "statuscode",
      label: t("HPI.CaseMatching.CaseStatus", { defaultValue: "Case Status" }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.CaseStatus", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "statuscode")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_customertrackingnumber",
      label: t("HPI.CaseMatching.InternalCustomerTracking", {
        defaultValue: "Internal customer tracking number",
      }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.InternalCustomerTracking", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_customertrackingnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "createdon",
      label: t("HPI.CaseMatching.DateSubmitted", {
        defaultValue: "Date submitted",
      }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.DateSubmitted", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "createdon")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "modifiedon",
      label: t("HPI.CaseMatching.LastUpdated", {
        defaultValue: "Last updated",
      }),
      filter: (
        <Search
          placeholder={t("HPI.CaseMatching.LastUpdated", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "modifiedon")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
  ];
  const setTableFliterData = (matchingcaseGrid: any) => {
    const formattedData = matchingcaseGrid.map((item: any) => ({
      hpi_caseid: clickOnRowItems(item, item.hpi_caseid),
      hpi_subject: item.hpi_subject,
      statuscode: item.statuscode,
      hpi_customertrackingnumber: item.hpi_customertrackingnumber,
      createdon: item.createdon,
      modifiedon: item.modifiedon,
    }));
    setTableData(formattedData);
    setFilteredData(formattedData);
  };
  const clickOnRowItems = (item: any, name: any) => {
    return (
      <button className="link" onClick={(e) => handleRowSelected(item, e)}>
        <span>{name}</span>
      </button>
    );
  };

  const handleRowSelected = (data: any, e: any) => {
    let uri = `cid=${data.incidentid}`;
    navigate(`/edit-case?${uri}`, { state: { data } });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setProgress(true);
      try {
        const payloadMatchCount = {
          ainfo: searchParams.get("ainfo"),
          pno: searchParams.get("pno"),
          contactid: "85680c15-7814-e711-80fc-5065f38ad971",
          
          
        };
        const matchCount = await apiPost(
          POST_GET_MATCH_COUNT,
          payloadMatchCount
        );

        if (matchCount.data && matchCount.data.result === false) {
          navigate(
            `/create-case?ainfo=${searchParams.get(
              "ainfo"
            )}&pno=${searchParams.get("pno")}`
          );
        } else {
          setShowMatch(true);
          try {
            let payload = {
              ainfo: searchParams.get("ainfo"),
              pno: searchParams.get("pinfo"),
              
              
            };
            const response = await apiPost(
              POST_PRODUCT_LOAD_MATCHING_CASE,
              payload
            );
            if (response.data) {
              const matchingcaseGrid = JSON.parse(
                response.data.matchingcaseGrid
              );
              setPageLoad(matchingcaseGrid);
              const lblCaseWarningMessages =
                response.data.lblCaseWarningMessage;
              let exporteddata = matchingcaseGrid.map((item: any) => ({
                "Case ID": item.hpi_caseid,
                "Case Title": item.hpi_subject,
                "Case Status": item.statuscode,
                "Internal customer tracking number":
                  item.hpi_customertrackingnumber,
                "Date submitted": item.createdon,
                "Last updated": item.modifiedon,
              }));
              setData(exporteddata);
              setTableFliterData(matchingcaseGrid);
              setlblCaseWarningMessage(lblCaseWarningMessages);

              try {
                let payload = {
                  ainfo: searchParams.get("ainfo"),
                  pinfo: searchParams.get("pinfo"),
                  pno: searchParams.get("pno"),
                  contactid: "85680C15-7814-E711-80FC-5065F38AD971",
                  
                  
                };
                const response = await apiPost(POST_PRODUCT_INFO, payload);
                if (response.data) {
                  let productData = response.data;
                  setProductInfo(productData);
                }
                setPolyProductInfo(payload);
              } catch (err) {
                setError("Failed ");
                setLoading(false);
              }
            }
          } catch (err) {
            setError("Failed ");
            setLoading(false);
          }
        }
      } catch (err) {
        setError("Failed ");
        setLoading(false);
        setProgress(false);
      }
      setProgress(false);
    };
    fetchData();
  }, []);
  const handleClick = (e: any) => {
    navigate(
      `/create-case?ainfo=${searchParams.get("ainfo")}&pno=${searchParams.get(
        "pno"
      )}`
    );
  };
  return (
    <>
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      {showMatch && (
        <Container fluid>
          <div className="matching-case">
            <div className="header">
              <h2>{t('HPI.CaseMatching.MatchingCase',{defaultValue:'Matching Case'})}</h2>
            </div>
            <Card
              //background="filled"
              className="bg-clr"
              border="none"
              content={
                <Container className="card-container">
                  <Row>
                    <CaseItems
                      data={getProductInfo}
                      polyData={getPolyProductInfo}
                      selectedcasepriority={pageLoad?.selectedcasepriority}
                    />
                  </Row>
                  <Row className="detail-container">
                    <Col sm={9}>
                      <h4>
                        {t("HPI.CaseMatching.CaseMatch", {
                          defaultValue: "Case match warning",
                        })}
                      </h4>
                    </Col>
                    <Col sm={3} className="align-right">
                      <Exporttoexcel fileName="All Case Match" rows={data} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <p>{lblCaseWarningMessage}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Table
                        columns={columns}
                        data={pagedData as any}
                        showFilters
                        pagination={paginationProps}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4 justify-content-between">
                    <Col md={10}>
                      <label>
                        {t("HPI.CaseMatching.CreatenewCase", {
                          defaultValue: "Continue with creating a new case.",
                        })}
                      </label>
                    </Col>
                    <Col md={2}>
                      {" "}
                      <Button onClick={(e) => handleClick(e)}>
                        {t("HPI.Continue", { defaultValue: "Continue" })}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              }
            />
          </div>
        </Container>
      )}
    </>
  );
};
